import { AfterViewInit, Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { AppState } from 'src/app/app.state';
import { CastRole } from 'src/app/enums/cast-role.enum';
import { Catchup } from 'src/app/model/cms-vod-core/catchup-models/catchup-model';
import { Genre } from 'src/app/model/cms-vod-core/content-controller/genre-model';
import { ContentCast } from 'src/app/model/content-cast.model';
import { ContentLanguageMetadata } from 'src/app/model/content-language-metadata.model';
import { Content } from 'src/app/model/content.model';
import { TheMovieDb } from 'src/app/model/imdb-model';
import { MetadataCastTypeMap } from 'src/app/model/metadata-cast-type-map.model';
import { Metadata } from 'src/app/model/metadata.model';
import { Search } from 'src/app/model/omdb-tmdb-models/omdb.model';
import { CatchupService } from 'src/app/services/cms-vod-core/catchup-service/catchup.service';
import { ContentLanguageMetadataService } from 'src/app/services/cms-vod-core/content-language-metadata-controller/content-language-metadata.service';
import { ContentService } from 'src/app/services/cms-vod-core/contents-controller/content.service';
import { GenreService } from 'src/app/services/cms-vod-core/genre-controller/genre.service';
import { ThemoviedbService } from 'src/app/services/cms-vod-core/themoviedb-controller/themoviedb.service';
import * as RefreshActions from 'src/app/utility/actions/refresh-state.actions';
import { Utility } from 'src/app/utility/utility';
import { Types } from '../../../../../enums/types.enum';
import { DataSharingService } from '../../../../../main/data-sharing.service';
import { ComingSoonContent } from '../../../../../model/coming-soon-content.model';
import { CastControllerService } from '../../../../../services/cast-controller/cast-controller.service';
import { ComingSoonContentsService } from '../../../../../services/cms-vod-core/coming-soon-contents/coming-soon-contents.service';
import { ImdbService } from '../../../../../services/imbd-service/imdb.service';
import { RefreshManagerService, RefreshTarget } from 'src/app/main/RefreshManagerService';
import { ContentLanguage } from 'src/app/model/cms-vod-core/content-language.model';
import { ContentLanguageService } from 'src/app/services/cms-vod-core/content-language-service/content-language.service';

@Component({
  selector: 'app-imdb',
  templateUrl: './imdb.component.html',
  styleUrls: ['./imdb.component.scss'],
})
export class ImdbComponent implements OnInit, AfterViewInit, OnDestroy {
  content: Content = new Content();
  objectId: number;
  catchup: Catchup = new Catchup();
  comingSoonContent: ComingSoonContent = new ComingSoonContent();
  vodType: string;
  originalTitle: string;
  imdbId: string;
  omdbResult: any;
  copyMetadataToForeingLang: boolean = false;
  castsWithPosters: TheMovieDb = new TheMovieDb();
  suggestedCasts: ContentCast[] = [];
  castExist: boolean = false;
  casts: ContentCast[] = [];
  cast: ContentCast;
  languages: ContentLanguage[] = [];
  isCopy: boolean = false;
  genres: Genre[] = [];
  updateChild: boolean = false;
  isChildUpdate: boolean = false;
  loading: boolean = true;
  state: Observable<boolean>;
  constructor(
    private metadataLanguageService: ContentLanguageMetadataService,
    private comingSoonContentService: ComingSoonContentsService,
    private dataSharingService: DataSharingService,
    private refreshManager: RefreshManagerService,
    private theMovieDbService: ThemoviedbService,
    private castService: CastControllerService,
    private languageService: ContentLanguageService,
    private catchupService: CatchupService,
    private contentService: ContentService,
    private genreService: GenreService,
    private imdbService: ImdbService,
    private route: ActivatedRoute,
    private store: Store<AppState>,
    public utility: Utility,
  ) {
    this.state = this.store.select('status');
  }

  ngOnInit(): void {
    this.objectId = this.route.snapshot.params['id'];
    this.imdbId = this.route.snapshot.params['imdbId'];
    this.vodType = this.route.snapshot.params['vodType'];
    this.getAllCasts();
    if (this.objectId && this.vodType == 'Vod') {
      this.getContentById(this.objectId);
    } else if (this.objectId && this.vodType == 'Cutv') {
      this.getCatchupById(this.objectId);
    } else if (this.objectId && this.vodType == 'ComingSoon') {
      this.getComingSoonContentById(this.objectId);
    }

    this.getAllLanguages();
  }

  ngAfterViewInit(): void {
    this.utility.openModal('imdb');
  }

  ngOnDestroy(): void {
    if (this.objectId && this.vodType == 'ComingSoon') {
      this.store.dispatch(new RefreshActions.RefreshState(true));
    }
  }

  getContentById(contentId: number): void {
    this.contentService.getContentById(contentId).subscribe((response) => {
      this.content = response;
      // let season: number = response.metadata.seasonNo;
      // let episode: number = response.metadata.episodeNo;
      let type: string = response.type;

      this.getImdbDataByImdbId(type, null, null);

      if (this.content.type == Types.MOVIE) {
        this.getCastsPosters(this.imdbId, false);
      } else {
        this.getCastsPostersForSeries(this.imdbId);
      }
    });
  }

  getCatchupById(catchupId: number): void {
    this.catchupService.getCatchupById(catchupId).subscribe((response) => {
      this.catchup = response;
      // let season: number = response.metadata.seasonNo;
      // let episode: number = response.metadata.episodeNo;
      let type: string = response.type;
      this.getImdbDataByImdbId(type, null, null);
      if (this.catchup.type == Types.MOVIE) {
        this.getCastsPosters(this.imdbId, false);
      } else {
        this.getCastsPostersForSeries(this.imdbId);
      }
    });
  }

  getComingSoonContentById(objectId: number): void {
    this.comingSoonContentService.getComingSoonContentById(objectId).subscribe((response) => {
      this.comingSoonContent = response;
      //let season: number = response.metadata.seasonNo;
      //let episode: number = response.metadata.episodeNo;

      this.getImdbDataByImdbId(null, null, null);
      if (this.comingSoonContent.content.type == Types.MOVIE) {
        this.getCastsPosters(this.imdbId, false);
      } else {
        this.getCastsPostersForSeries(this.imdbId);
      }
    });
  }

  getImdbDataByImdbId(type: string, seasonNo: number, episodeNo: number): void {
    let season: number = 0;
    let episode: number = 0;
    if (type == 'EPISODE') {
      season = season;
      episode = episode;
    }
    this.theMovieDbService.getImdbDetailData(this.imdbId, seasonNo, episodeNo).subscribe(
      (response) => {
        this.omdbResult = response;
        this.loading = false; // Veri geldikten sonra false yapılıyor
      },
      (error) => {
        this.loading = false;
        // Hata yönetimi burada yapılabilir
      },
    );
  }

  getCastsPosters(imdbId: string, isSerie: boolean): void {
    this.imdbService.getCasts(imdbId, isSerie).subscribe((data) => {
      this.castsWithPosters = data;
    });
  }

  getCastsPostersForSeries(imdbId?: string): void {
    this.imdbService.getDetailOfContentFromMovieDb(imdbId).subscribe((response) => {
      this.getPosters(response.tv_results[0].id);
    });
  }

  getPosters(moviedbId: number): void {
    this.imdbService.getTvShowCasts(moviedbId).subscribe((response) => {
      this.castsWithPosters = response;
    });
  }

  getCastsPostersForSeason(imdbId: string, seasonNo: number): void {
    this.imdbService.getSeasonCasts(imdbId, seasonNo).subscribe((data) => {
      this.castsWithPosters = data;
    });
  }

  getCastsPostersForEpisode(imdbId: string, seasonNo: number, episodeNo: string): void {
    this.imdbService.getEpisodeCasts(imdbId, seasonNo, episodeNo).subscribe((data) => {
      this.castsWithPosters = data;
    });
  }

  updateMetadata(updateMetadata: Search): void {
    this.loading = true;
    if (this.vodType == 'Vod') {
      this.content.metadata = this.imdbInfoParser(updateMetadata, this.content.metadata);

      let contentLanguageMetadata: ContentLanguageMetadata = new ContentLanguageMetadata();
      let genreArray: string[] = updateMetadata.Genre.split(',');
      let copyEnglishMetadata = false;

      if (this.isCopy && !updateMetadata.Language.includes('Turkish')) {
        contentLanguageMetadata.metadata = { id: this.content.metadata.id };
        contentLanguageMetadata.genres = [];
        let eng: ContentLanguage = this.languages.find((lang) => lang.languageCode == 'en');
        contentLanguageMetadata.language = eng;
        contentLanguageMetadata.genres = this.engGenres(updateMetadata.Genre);

        // if (!updateMetadata.Plot.includes('N/A')) {
        contentLanguageMetadata.summaryLong = updateMetadata.Plot;
        contentLanguageMetadata.summaryShort = updateMetadata.Plot;
        // }

        if (!updateMetadata.Plot.includes('N/A')) {
          this.content.metadata.originalSummaryLong = updateMetadata.Plot;
        }

        if (!updateMetadata.Title.includes('N/A')) {
          contentLanguageMetadata.titleBrief = updateMetadata.Title;
          contentLanguageMetadata.title = updateMetadata.Title;
        }

        // Without an english language row or a title the backend has nothing to save, so skip the
        // language metadata call instead of sending a payload it rejects.
        copyEnglishMetadata = !!eng && !!contentLanguageMetadata.title;
      }

      this.content.metadata.metadataCastTypeMaps = new Array<MetadataCastTypeMap>();

      if (!this.castsWithPosters.crew || this.castsWithPosters.crew.length < 1) {
        let directors: string[] = updateMetadata.Director.split(',');
        for (const direct of directors) {
          if (!direct.includes('N/A')) {
            let director: MetadataCastTypeMap = new MetadataCastTypeMap();
            director.cast = new ContentCast();
            director.cast.name = direct.trim();
            director.castType = CastRole.Director;
            this.content.metadata.metadataCastTypeMaps.push(director);
          }
        }
      }

      if (!this.castsWithPosters.cast || this.castsWithPosters.cast.length < 1) {
        let actors: string[] = updateMetadata.Actors.split(',');
        for (const actor of actors) {
          if (!actor.includes('N/A')) {
            let actorMap: MetadataCastTypeMap = new MetadataCastTypeMap();
            actorMap.cast = new ContentCast();
            actorMap.cast.name = actor.trim();
            actorMap.castType = CastRole.Actor;
            this.content.metadata.metadataCastTypeMaps.push(actorMap);
          }
        }
      }

      if (this.castsWithPosters.crew) {
        for (const direct of this.castsWithPosters.crew) {
          if (direct.job == 'Director' && direct.name !== 'N/A') {
            let director: MetadataCastTypeMap = new MetadataCastTypeMap();
            director.cast = new ContentCast();
            director.cast.name = direct.name;
            director.castType = CastRole.Director;
            director.cast.posterUrl = null;
            this.content.metadata.metadataCastTypeMaps.push(director);
          }
        }
      }

      if (this.castsWithPosters.cast) {
        for (const act of this.castsWithPosters.cast.slice(0, 5)) {
          if (act.known_for_department == 'Acting') {
            let actor: MetadataCastTypeMap = new MetadataCastTypeMap();
            actor.cast = new ContentCast();
            actor.cast.name = act.name;
            actor.castType = CastRole.Actor;
            actor.cast.posterUrl = null;
            if (!this.castChecker(actor)) {
              this.content.metadata.metadataCastTypeMaps.push(actor);
            }
          }
        }
      }

      this.contentService.updateContentPromise(this.content, this.isChildUpdate).then((response: Content) => {
        if (response) {
          if (this.content.metadata.contentLanguageMetadatas.length && copyEnglishMetadata) {
            contentLanguageMetadata.id = this.content.metadata.contentLanguageMetadatas[0].id;
            this.metadataLanguageService.editContentLanguageMetadata(contentLanguageMetadata, this.updateChild).subscribe((_) => {
              this.refreshManager.sendRefresh(RefreshTarget.VOD_EDIT);
            });
          } else if (this.content.metadata.contentLanguageMetadatas.length < 1 && copyEnglishMetadata) {
            this.metadataLanguageService.addContentLanguageMetadata(contentLanguageMetadata, this.updateChild).subscribe((_) => {
              this.refreshManager.sendRefresh(RefreshTarget.VOD_EDIT);
            });
          } else {
            this.store.dispatch(new RefreshActions.RefreshState(false));
            this.refreshManager.sendRefresh(RefreshTarget.VOD_EDIT);
          }
          this.utility.closeModalInMethod('imdb');
        }
        this.loading = false;
      });
    } else if (this.vodType == 'Cutv') {
      this.catchup.metadata.contentLanguageMetadatas = new Array<ContentLanguageMetadata>();

      this.catchup.metadata = this.imdbInfoParser(updateMetadata, this.catchup.metadata);

      let contentLanguageMetadata: ContentLanguageMetadata = new ContentLanguageMetadata();
      let copyEnglishMetadata = false;

      if (this.isCopy && !updateMetadata.Language.includes('Turkish')) {
        contentLanguageMetadata.metadata = { id: this.catchup.metadata.id };
        contentLanguageMetadata.genres = [];
        let eng: ContentLanguage = this.languages.find((lang) => lang.languageCode == 'en');
        contentLanguageMetadata.language = eng;
        contentLanguageMetadata.genres = this.engGenres(updateMetadata.Genre);
        contentLanguageMetadata.summaryLong = updateMetadata.Plot;
        contentLanguageMetadata.summaryShort = updateMetadata.Plot;

        if (!updateMetadata.Plot.includes('N/A')) {
          this.catchup.metadata.originalSummaryLong = updateMetadata.Plot;
        }

        if (!updateMetadata.Title.includes('N/A')) {
          contentLanguageMetadata.titleBrief = updateMetadata.Title;
          contentLanguageMetadata.title = updateMetadata.Title;
        }

        copyEnglishMetadata = !!eng && !!contentLanguageMetadata.title;
      }

      this.catchup.metadata.metadataCastTypeMaps = new Array<MetadataCastTypeMap>();

      if (!this.castsWithPosters.crew || this.castsWithPosters.crew.length < 1) {
        let directors: string[] = updateMetadata.Director.split(',');
        for (const direct of directors) {
          if (!direct.includes('N/A')) {
            let director: MetadataCastTypeMap = new MetadataCastTypeMap();
            director.cast = new ContentCast();
            director.cast.name = direct.trim();
            director.castType = CastRole.Director;
            this.catchup.metadata.metadataCastTypeMaps.push(director);
          }
        }
      }

      if (!this.castsWithPosters.cast || this.castsWithPosters.cast.length < 1) {
        let actors: string[] = updateMetadata.Actors.split(',');
        for (const actor of actors) {
          if (!actor.includes('N/A')) {
            let actorMap: MetadataCastTypeMap = new MetadataCastTypeMap();
            actorMap.cast = new ContentCast();
            actorMap.cast.name = actor.trim();
            actorMap.castType = CastRole.Actor;
            this.catchup.metadata.metadataCastTypeMaps.push(actorMap);
          }
        }
      }

      if (this.castsWithPosters.crew) {
        for (const direct of this.castsWithPosters.crew) {
          if (direct.job == 'Director' && direct.name !== 'N/A') {
            let director: MetadataCastTypeMap = new MetadataCastTypeMap();
            director.cast = new ContentCast();
            director.cast.name = direct.name;
            director.castType = CastRole.Director;
            director.cast.posterUrl = null;
            this.catchup.metadata.metadataCastTypeMaps.push(director);
          }
        }
      }

      if (this.castsWithPosters.cast) {
        for (const act of this.castsWithPosters.cast.slice(0, 5)) {
          if (act.known_for_department == 'Acting') {
            let actor: MetadataCastTypeMap = new MetadataCastTypeMap();
            actor.cast = new ContentCast();
            actor.cast.name = act.name;
            actor.castType = CastRole.Actor;
            actor.cast.posterUrl = null;
            if (!this.castChecker(actor)) {
              this.catchup.metadata.metadataCastTypeMaps.push(actor);
            }
          }
        }
      }

      this.catchupService.updateCatchupPromise(this.catchup, this.isChildUpdate).then((response: Catchup) => {
        if (response) {
          let metadataLang = this.catchup.metadata.contentLanguageMetadatas;
          if (metadataLang && metadataLang.length && copyEnglishMetadata) {
            contentLanguageMetadata.id = this.catchup.metadata.contentLanguageMetadatas[0].id;
            this.metadataLanguageService.editContentLanguageMetadata(contentLanguageMetadata, this.updateChild).subscribe((_) => {
              this.refreshManager.sendRefresh(RefreshTarget.VOD_EDIT);
            });
          }
          if ((!metadataLang || metadataLang.length < 1) && copyEnglishMetadata) {
            this.metadataLanguageService.addContentLanguageMetadata(contentLanguageMetadata, this.updateChild).subscribe((_) => {
              this.refreshManager.sendRefresh(RefreshTarget.VOD_EDIT);
            });
          } else if (!copyEnglishMetadata) {
            this.store.dispatch(new RefreshActions.RefreshState(false));
            this.refreshManager.sendRefresh(RefreshTarget.VOD_EDIT);
          }
          this.utility.closeModalInMethod('imdb');
        }
        this.loading = false;
      });
    } else {
      this.comingSoonContent.metadata = this.imdbInfoParser(updateMetadata, this.comingSoonContent.metadata);

      let contentLanguageMetadata: ContentLanguageMetadata = new ContentLanguageMetadata();
      let genreArray: string[] = updateMetadata.Genre.split(',');
      let copyEnglishMetadata = false;

      if (this.isCopy && !updateMetadata.Language.includes('Turkish')) {
        contentLanguageMetadata.metadata = { id: this.comingSoonContent.metadata.id };
        contentLanguageMetadata.genres = [];
        let eng: ContentLanguage = this.languages.find((lang) => lang.languageCode == 'en');
        contentLanguageMetadata.language = eng;
        contentLanguageMetadata.genres = this.engGenres(updateMetadata.Genre);

        // if (!updateMetadata.Plot.includes('N/A')) {
        contentLanguageMetadata.summaryLong = updateMetadata.Plot;
        contentLanguageMetadata.summaryShort = updateMetadata.Plot;
        // }

        if (!updateMetadata.Plot.includes('N/A')) {
          this.comingSoonContent.metadata.originalSummaryLong = updateMetadata.Plot;
        }

        if (!updateMetadata.Title.includes('N/A')) {
          contentLanguageMetadata.titleBrief = updateMetadata.Title;
          contentLanguageMetadata.title = updateMetadata.Title;
        }

        copyEnglishMetadata = !!eng && !!contentLanguageMetadata.title;
      }

      this.comingSoonContent.metadata.metadataCastTypeMaps = new Array<MetadataCastTypeMap>();

      if (!this.castsWithPosters.crew || this.castsWithPosters.crew.length < 1) {
        let directors: string[] = updateMetadata.Director.split(',');
        for (const direct of directors) {
          if (!direct.includes('N/A')) {
            let director: MetadataCastTypeMap = new MetadataCastTypeMap();
            director.cast = new ContentCast();
            director.cast.name = direct.trim();
            director.castType = CastRole.Director;
            this.comingSoonContent.metadata.metadataCastTypeMaps.push(director);
          }
        }
      }

      if (!this.castsWithPosters.cast || this.castsWithPosters.cast.length < 1) {
        let actors: string[] = updateMetadata.Actors.split(',');
        for (const actor of actors) {
          if (!actor.includes('N/A')) {
            let actorMap: MetadataCastTypeMap = new MetadataCastTypeMap();
            actorMap.cast = new ContentCast();
            actorMap.cast.name = actor.trim();
            actorMap.castType = CastRole.Actor;
            this.comingSoonContent.metadata.metadataCastTypeMaps.push(actorMap);
          }
        }
      }

      if (this.castsWithPosters.crew) {
        for (const direct of this.castsWithPosters.crew) {
          if (direct.job == 'Director' && direct.name !== 'N/A') {
            let director: MetadataCastTypeMap = new MetadataCastTypeMap();
            director.cast = new ContentCast();
            director.cast.name = direct.name;
            director.castType = CastRole.Director;
            director.cast.posterUrl = null;
            this.comingSoonContent.metadata.metadataCastTypeMaps.push(director);
          }
        }
      }

      if (this.castsWithPosters.cast) {
        for (const act of this.castsWithPosters.cast.slice(0, 5)) {
          if (act.known_for_department == 'Acting') {
            let actor: MetadataCastTypeMap = new MetadataCastTypeMap();
            actor.cast = new ContentCast();
            actor.cast.name = act.name;
            actor.castType = CastRole.Actor;
            actor.cast.posterUrl = null;
            if (!this.castChecker(actor)) {
              this.comingSoonContent.metadata.metadataCastTypeMaps.push(actor);
            }
          }
        }
      }

      this.comingSoonContentService.updateComingSoonContentPromise(this.comingSoonContent).then((response: Content) => {
        if (response) {
          if (this.comingSoonContent.metadata.contentLanguageMetadatas.length && copyEnglishMetadata) {
            contentLanguageMetadata.id = this.comingSoonContent.metadata.contentLanguageMetadatas[0].id;
            this.metadataLanguageService.editContentLanguageMetadata(contentLanguageMetadata, this.updateChild).subscribe((_) => {
              this.refreshManager.sendRefresh(RefreshTarget.VOD_EDIT);
              // this.utility.closeModalInMethod('imdb');
            });
          } else if (this.comingSoonContent.metadata.contentLanguageMetadatas.length < 1 && copyEnglishMetadata) {
            this.metadataLanguageService.addContentLanguageMetadata(contentLanguageMetadata, this.updateChild).subscribe((_) => {
              this.refreshManager.sendRefresh(RefreshTarget.VOD_EDIT);
              // this.utility.closeModalInMethod('imdb');
            });
          } else {
            this.store.dispatch(new RefreshActions.RefreshState(true));
            this.refreshManager.sendRefresh(RefreshTarget.VOD_EDIT);
          }
          //this.store.dispatch(new RefreshActions.RefreshState(true));
          this.utility.closeModalInMethod('imdb');
        }
        this.loading = false;
      });
    }
  }

  castChecker(metadataCastTypeMap: MetadataCastTypeMap): boolean {
    if (!metadataCastTypeMap.cast.name.includes('N/A')) {
      if (this.vodType == 'content') {
        for (const castTypeMap of this.content.metadata.metadataCastTypeMaps) {
          if (castTypeMap.cast.name.includes(metadataCastTypeMap.cast.name) && castTypeMap.castType == metadataCastTypeMap.castType) {
            return true;
          } else {
            return false;
          }
        }
      }
    } else if (this.vodType == 'Cutv') {
      for (const castTypeMap of this.catchup.metadata.metadataCastTypeMaps) {
        if (castTypeMap.cast.name.includes(metadataCastTypeMap.cast.name) && castTypeMap.castType == metadataCastTypeMap.castType) {
          return true;
        } else {
          return false;
        }
      }
    } else {
      for (const castTypeMap of this.comingSoonContent.metadata.metadataCastTypeMaps) {
        if (castTypeMap.cast.name.includes(metadataCastTypeMap.cast.name) && castTypeMap.castType == metadataCastTypeMap.castType) {
          return true;
        } else {
          return false;
        }
      }
    }
    return false;
  }

  getAllCasts(): void {
    this.castService.getAllCasts(null, null, null, null, null).subscribe((response) => {
      this.suggestedCasts = response;
    });
  }

  getAllLanguages(): void {
    this.languageService.getAllActiveContentLanguage().subscribe((response) => {
      this.languages = response;
      let eng: ContentLanguage = this.languages.find((item) => {
        if (item.languageCode == 'en') {
          return item;
        }
      });
      if (eng) {
        this.getAllGenreByLanguageId(eng.id);
      }
    });
  }

  getAllGenreByLanguageId(languageId: number): void {
    this.genreService.getAllGenre(languageId).subscribe((response) => {
      this.genres = response;
    });
  }

  engGenres(genre: string): Genre[] {
    let genres: Genre[] = [];
    let splittedGenres: string[] = genre.split(',');
    for (const splittedGenre of splittedGenres) {
      for (const genre of this.genres) {
        if (genre.name != null) {
          if (splittedGenre.trim() == genre.name.trim()) {
            genres.push(genre);
          }
        }
      }
    }
    return genres;
  }

  imdbInfoParser(imdb: Search, metadata: Metadata): Metadata {
    let newMeadata: Metadata = new Metadata();
    newMeadata = metadata;

    if (!metadata.year || !metadata.year.trim()) {
      let imdbYear: string = this.parseImdbYear(imdb.Year);
      if (imdbYear) {
        newMeadata.year = imdbYear;
      }
    }

    if (!imdb.imdbID.includes('N/A')) {
      newMeadata.imdbId = imdb.imdbID;
    }

    if (!imdb.Country.includes('N/A')) {
      newMeadata.country = imdb.Country;
    }

    if (!imdb.Language.includes('N/A')) {
      newMeadata.originalLanguage = imdb.Language;
    }

    if (!imdb.imdbRating.includes('N/A')) {
      newMeadata.imdbRating = imdb.imdbRating;
    }

    if (!imdb.Title.includes('N/A')) {
      newMeadata.originalTitle = imdb.Title;
    }

    return newMeadata;
  }

  // OMDb returns "1994" for movies but ranges such as "2008-2013" for series, while the
  // year input on the edit form only accepts digits (pattern="\d*"), so keep the first year.
  parseImdbYear(year: string): string {
    if (!year || year.includes('N/A')) {
      return null;
    }
    let match: RegExpMatchArray = year.match(/\d{4}/);
    return match ? match[0] : null;
  }
}
